const ALLOWED_TAGS = ['b', 'strong', 'em', 'i', 'br', 'p', 'ul', 'ol', 'li'];

/**
 * Strips HTML tags that are not in the allowlist.
 * Only permits simple formatting tags with no attributes.
 */
export function sanitizeHtml(html: string): string {
  return html.replace(/<\/?([a-zA-Z][a-zA-Z0-9]*)\b[^>]*\/?>/g, (match, tag) => {
    const normalizedTag = tag.toLowerCase();
    if (ALLOWED_TAGS.includes(normalizedTag)) {
      const isClosing = match.startsWith('</');
      const isSelfClosing = match.endsWith('/>');
      if (isClosing) return `</${normalizedTag}>`;
      if (isSelfClosing) return `<${normalizedTag}/>`;
      return `<${normalizedTag}>`;
    }
    return '';
  });
}
